import Aos from "aos";
import '../../node_modules/aos/dist/aos.css';

Aos.init({
  duration: 750,
  delay: 200,
  startEvent: 'load',
})
